import JP from 'iview/dist/locale/ja-JP'
import jaE from 'element-ui/lib/locale/lang/ja'

const jaJP = Object.assign({
  menu: {
    home: 'ホームページ',
    system: 'システム設定',
    system_management: {
      Role: '役割',
      Department: '部門',
      Account: 'アカウント',
      WorkTime: 'シフト',
      WorkType: '労働者タイプ',
      RoleEdit: '役割編集',
      DepartmentEdit: '部門編集',
      AccountEdit: 'アカウント編集',
      WorkTimeEdit: 'シフト編集',
      WorkTypeEdit: 'ワーカータイプ編集',
      systeminfo: 'システム情報',
      SystemAuth: '承認管理'
    },
    Device: '設備設定',
    Device_management: {
      RouterList: 'ルーター',
      RouterEdit: 'ルーター編集',
      Collector: '設備',
      CollectorEdit: '設備編集',
      CollectorGroup: 'マシングループ',
      CollectorGroupEdit: 'マシングループ編集'
    },
    Card: 'カード設定',
    CardEdit: 'カード編集',
    People: '人員設定',
    PeopleEdit: '人員編集',
    Product: '製品管理',
    ProductEdit: '製品編集',
    Order: '注文管理',
    OrderEdit: '注文編集',
    Plan: '生産管理',
    Plan_Management: {
      Production_plan: 'オーダー管理',
      Production_management: 'オーダー調整管理',
      Production_order: 'オーダースケジュール'
    },
    Monitor: 'モニタリング',
    Monitor_Monitoring: {
      Collector: '設備',
      Order: '注文管理'
    },
    Data: 'レポート',
    Data_output: {
      Order: '注文管理',
      device: '設備設定',
      Worker: '人員履歴',
      MaintainList: 'メンテナンス履歴',
      MaintainEdit: 'メンテナンス編集'
    },
    Setting: 'ユーザー設定'
  },
  system: {
    Account: {
      New_account: '新規アカウント作成',
      edit_account: 'アカウント編集',
      please_enter: '入力してください',
      please_choose: '選んでください',
      Return_to_account_list: 'アカウントリストに戻る',
      User_name: 'ユーザー名',
      User_name_message: 'ユーザー名を入力してください',
      Name: '名前',
      Name_message: '名前を入力してください',
      Role: '役割',
      Role_message: '役割を選択してください',
      Worker_number: '労働者番号',
      Department: '部門',
      Department_message: '部門を選択してください',
      Telephone: '電話',
      Email: 'Eメール',
      QQ: 'QQ',
      Wechat: 'Wechat',
      telephone: '電話',
      email: 'Eメール',
      qq: 'QQ',
      wechat: 'Wechat',
      save: '保存',
      index: 'No.',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      reseat: 'リセット',
      error: 'エラー',
      error_message1: '<p>アカウント重複</ p>',
      error_message2: '<p>アカウント重複</ p>',
      delete_message: '削除しますか？'
    },
    Department: {
      New_Department: '新規部門',
      edit_Department: '部門編集',
      index: 'No.',
      Department: '部門',
      Authorization: '承認',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_depatement_list: '部門リストに戻る',
      name: '名前',
      Move_left: '左に移動する',
      Move_right: '右に移動する',
      save: '保存',
      All_authorization: '全承認',
      Department_authorization: '部署承認'
    },
    Role: {
      New_Role: '新規役割',
      edit_Role: '役割編集',
      index: 'No.',
      Role: '役割',
      Authorization: '承認',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_role_list: '役割リストに戻る',
      name: '名前',
      Move_left: '左に移動する',
      Move_right: '右に移動する',
      save: '保存',
      All_authorization: '全承認',
      Role_authorization: 'ロール認証'
    },
    workTime: {
      New_workTime: '新しいシフト',
      edit_workTime: 'シフト編集',
      index: 'No.',
      name: '名前',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      please_choose: '選んでください',
      startTime: '始動時間',
      endTime: '終了時間',
      Return_to_workTime_list: 'シフトリストに戻す',
      save: '保存'
    },
    workType: {
      New_workType: '新しいワーカータイプ',
      edit_workType: 'ワーカータイプの編集',
      index: 'No.',
      name: '名前',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_workType_list: 'ワーカータイプリストに戻る',
      save: '保存',
      yes: 'はい',
      no: 'いいえ',
      outputValid: '効果的な生産',
      monopoly: '占有機',
      maintain: 'モードを維持する',
      warn: 'シャットダウンアラーム',
      Sorting: '並べ替え',
      display: 'ダッシュボード',
      malfunction: 'フォルト計算',
      remark: 'リマーク'
    },
    SystemAuth: {
      Information: '情報',
      systemVersion: 'システムバージョン：',
      systemDealTime: '有効期限：',
      please_enter: '入力してください',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '認証番号'
    },
    SystemInfo: {
      Information: '情報',
      Contect: '連絡',
      systemName: 'システム名：',
      please_enter: '入力してください',
      name: '名前',
      contact: 'コンテント名：',
      address: '会社住所：',
      phone: '電話：',
      fax: 'ファックス：',
      eMail: 'Eメール',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: 'シャットダウンアラーム間隔：'
    }
  },
  device: {
    collector: {
      New_collector: '新規設備',
      edit_collector: '設備編集',
      Return_to_collector_list: 'マシンリストに戻る',
      name: '名前',
      deviceNo: 'No.',
      routerID: 'ルーター',
      type: 'マシンタイプ',
      computeType: '生産量計算方法',
      length: 'ローラー円周',
      count: '幅番号',
      width: 'テープ幅',
      deviceCompany: '設備メーカー',
      deviceModel: '設備モデル番号',
      buyTime: '購入時間',
      deviceLifeTime: '購入年数（年）',
      please_enter: '入力してください',
      please_enter_mm: '入力してください（単位：mm）',
      save: '保存',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      error: 'エラー',
      error_message1: '<p>アカウント重複</ p>',
      error_message2: '<p>アカウント重複</ p>',
      remark: 'リマーク',
      Message: {
        name: '名前',
        deviceNo: 'No.',
        computeType: '生産量計算方法',
        routerID: 'ルーター',
        length: 'ローラー円周',
        count: '幅番号',
        width: 'テープ幅'
      }
    },
    group: {
      New_group: '新しいマシングループ',
      edit_group: 'マシングループの編集',
      Return_to_group_list: 'マシングループリストに戻る',
      please_enter: '入力してください',
      save: '保存',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      index: 'No.',
      name: '名前',
      chosen: '選択しました',
      devices: '機械',
      remark: 'リマーク',
      width: 'テープ幅',
      router: 'ルーター'
    },
    router: {
      New_router: '新しいルーター',
      edit_router: 'ルータの編集',
      Return_to_router_list: 'ルータのリストに戻る',
      please_enter: '入力してください',
      index: 'No.',
      name: '名前',
      AnotherName: 'ルータ名',
      linkType: 'ネットワークタイプ',
      channel: 'シグナルチャネル',
      remark: 'リマーク',
      save: '保存',
      action: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      mod: 'ネットワークタイプ',
      Lan: 'ローカルLAN',
      Internet: 'インターネット',
      time: '並べ替え',
      save_success: '保存成功'
    }
  },
  Card: {
    New_Card: '新しいカード',
    edit_Card: 'カード編集',
    Return_to_Card_list: 'カードリストに戻る',
    please_enter: '入力してください',
    index: 'No.',
    userName: '所有者',
    cardNo: 'カード番号',
    workTypeName: 'ワークタイプ',
    action: '操作',
    edit: '編集',
    delete: '削除',
    delete_message: '削除しますか？',
    save: '保存',
    error: 'エラー',
    error_message1: '<p>アカウント重複</ p>',
    error_message2: '<p>アカウント重複</ p>'
  },
  Product: {
    New_Product: '新製品',
    edit_Product: '商品の編集',
    Return_to_Product_list: '製品リストに戻る',
    please_enter: '入力してください',
    index: 'No.',
    productNo: 'No.',
    name: '名前',
    latDensity: '緯糸密度',
    kaidu: 'テンション',
    width: 'テープ幅',
    specifications: '仕様',
    valid: '有効性',
    yes: 'はい',
    no: 'いいえ',
    action: '操作',
    edit: '編集',
    delete: '削除',
    delete_message: '削除しますか？',
    save: '保存',
    error: 'エラー',
    error_message: '<p>情報が完成していません</ p>',
    please_enter_mm: '入力してください（単位：mm）',
    please_enter_kaidu: '入力してください（≧1）',
    please_enter_latDensity: '入力してください（単位：weft / cm）',
    Message: {
      productNo: 'No.',
      name: '名前',
      latDensity: '緯糸密度',
      kaidu: 'テンション',
      width: 'テープ幅'
    }
  },
  Order: {
    New_Order: '新規注文',
    edit_Order: '注文の編集',
    Return_to_Order_list: '注文リストに戻る',
    please_enter: '入力してください',
    please_enter_date: '日付を入力してください',
    action: '操作',
    edit: '編集',
    delete: '削除',
    save: '保存',
    error: 'エラー',
    error_message1: '<p>アカウント重複</ p>',
    error_message2: '<p>アカウント重複</ p>',
    error_message3: '<p>数量が完了していません</ p>',
    error_message4: '<p>ユニットが未完了です</ p>',
    error_message5: '<p>配達日が未完了</ p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: '削除しますか？',
    change_message: 'あなたはケースを開きたいですか？',
    orderNo: '注文番号',
    customer: '顧客',
    ordersTime: '注文日',
    salesman: '販売',
    index: 'No.',
    productNo: 'No.',
    num: '数量',
    unit: '単位',
    attritionRate: 'ロス率（％）',
    deliveryTime: '出荷日',
    remark: 'リマーク',
    add: '注文に追加',
    Product_list: '製品リスト',
    search: '項目名',
    No_scheduling: '生産スケジュールなし',
    Not_production: '生産なし',
    Producting: '生産スケジュール始めて',
    Case_closed: '生産終了',
    name: '名前',
    Meter: 'メーター',
    Yard: 'ヤード',
    Gross: 'グロス',
    status: '状態',
    Message: {
      orderNo: '注文番号',
      ordersTime: '注文日',
      customer: '顧客',
      salesman: '販売'
    }
  },
  Login: {
    username: 'ユーザー名を入力してください',
    password: 'パスワードを入力してください',
    systemCode: 'システムコードを入力してください',
    language: '言語を選択してください',
    login: 'ログイン',
    system: 'システム設定',
    changePw: 'パスワードを変更する',
    logout: 'ログアウト',
    Information: '情報'
  },
  ChangePw: {
    oldPassword: '古いパスワードを入力：',
    newPassword: '新しいパスワードを入力してください',
    comfirmPassword: '新しいパスワードを確認する',
    save: '保存',
    error: 'エラー',
    success: '変更を正常に完了',
    ChangePw: 'パスワードを変更する'
  },
  monitor: {
    Collector: {
      index: 'No.',
      name: '名前',
      group: 'グループ',
      deviceNo: 'No.',
      rpm: 'マシンRPM',
      status: '状態',
      status1: 'デバイスステータス',
      error: 'エラー',
      worker: '人員履歴',
      workType: '労働者タイプ',
      lastTime: '時間',
      timeout: 'オフライン',
      trial: 'トライアル',
      standby: '待機する',
      run: 'ランニング',
      orderNo: '注文番号',
      producNo: '製品番号',
      stop: '待機する',
      warp: '経糸',
      weft: ' 緯糸',
      thread: ' 糸',
      roll: ' ローラー'
    },
    Order: {
      index: 'No.',
      orderNo: '注文番号',
      producNo: '製品番号',
      salesman: '販売',
      ordersTime: '注文日',
      output: '生産',
      num: '数量',
      unit: '単位',
      countdata: 'マシン番号',
      name: '名前',
      rpm: 'マシンRPM',
      worker: '人員履歴',
      workType: '労働者タイプ',
      DailyOutput: '今日の生産量',
      deliveryTime: '出荷日',
      today: '今日の生産量',
      completed: '生産完了',
      fastestdelivery: '推定日',
      please_enter_date1: '注文の配信開始日',
      please_enter_date2: '注文の配信終了日',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス'
    }
  },
  data: {
    Device: {
      name: '名前',
      date: '日付',
      group: 'グループ',
      output: '生産',
      unit: '単位',
      runTotalTime: 'ランニングタイム',
      stopTime: 'ダウンタイム',
      stopTotalTime: 'ダウンタイム',
      error1Time: 'ワープ時間',
      error1TotalTime: 'ワープ時間',
      error2Time: '緯糸番号',
      error2TotalTime: '緯糸の時間',
      error3Time: '下糸の本数',
      error3TotalTime: 'ボトムタイム',
      error4Time: 'カール数',
      error4TotalTime: 'カール時間',
      S: '二番目',
      M: '分',
      H: '時間',
      D: '日',
      Meter: 'メーター',
      output_report: '生産量報告',
      run_report: '稼働状況表',
      please_enter: '選択してください',
      please_enter_date: '日付を選択してください',
      start_date: '開始日',
      end_date: '終了日',
      ok: '決定する',
      out: '出力',
      status: '状態'
    },
    Order: {
      orderNo: '注文番号',
      productNo: 'No.',
      collectorName: '設備',
      salesman: '販売',
      customer: '顧客',
      ordersTime: '注文日',
      productTime: '生産時間',
      output: '生産',
      target: '生産目標',
      num: '数量',
      unit: '単位',
      deliveryTime: '出荷日',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス',
      Order_report: '注文レポート',
      ok: '決定する',
      out: '出力',
      please_enter: '入力してください',
      please_enter_date: '日付を入力してください',
      start_date: '開始日',
      end_date: '終了日',
      time_range: 'Time range',
      No_scheduling: '生産スケジュールなし',
      Not_production: '生産なし',
      Producting: '生産スケジュール始めて',
      Case_closed: '生産終了',
      status: '状態'
    }
  },
  setting: {
    Basic_Information: '基本情報',
    company_information: '会社情報',
    Contact_information: '連絡先情報',
    save: '保存',
    please_enter: '入力してください',
    username: '所有者',
    name: '名前',
    company: '会社：',
    workNo: 'ジョブ番号：',
    department: '部門',
    workPosition: 'ポジション：',
    role: '役割',
    phone: '電話：',
    eMail: 'Eメール',
    qq: 'QQ',
    wechat: 'Wechat',
    System_setting: 'システム構成',
    language: '言語：',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '項目名',
      name: '名前',
      one: '最初のバッチ',
      two: '2番目のバッチ',
      three: '3番目のバッチ',
      four: '第4バッチ',
      fiv: '第5バッチ',
      six: '第6バッチ',
      orderNo: '注文番号',
      productNo: 'No.',
      row: '本数',
      delete_message: '削除しますか？',
      yes: 'はい',
      no: 'いいえ'
    },
    Order: {
      orderNo: '注文番号',
      customer: '顧客',
      ordersTime: '注文日',
      salesman: '販売',
      index: 'No.',
      productNo: 'No.',
      num: '数量',
      unit: '単位',
      attritionRate: 'ロス率（％）',
      output: '生産',
      deliveryTime: '出荷日',
      action: '操作',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス',
      delete_message: '削除しますか？',
      case1: 'オーダーを終わります',
      case2: 'オーダー完了'
    },
    Production: {
      productNo: 'No.',
      productName: '製品名',
      deliveryTime: '出荷日',
      num: '数量',
      name: '設備',
      count: '幅番号',
      width: 'テープ幅',
      collectorName: '設備',
      orderNo: '注文番号',
      planIndex: 'バッチ',
      row: '本数',
      action: '操作',
      delete: '削除',
      error: 'エラー',
      error_message: '<p>情報が完成していません</ p>',
      planClick: '予定された計画',
      please_enter: '入力してください',
      deviceNo: 'No.',
      save: '保存',
      save1: '注文',
      save2: 'オーダー入れ替え',
      save3: 'そして生産',
      No_scheduling: '生産スケジュールなし',
      Not_production: '生産なし',
      Producting: '生産スケジュール始めて',
      Case_closed: '生産終了',
      status: '状態',
      no: 'いいえ',
      delete_message: '削除しますか？',
      searchCollector: 'マシン名',
      chooose_order: '1.注文を選択',
      choose_device: '2.マシンを選択',
      choose_plan: '3.スケジュール計画',
      list: '予定された計画',
      message: 'この商品は閉じられています'
    }
  },
  People: {
    index: 'No.',
    name: '名前',
    workNo: 'ジョブ番号：',
    sex: 'ジェンダー',
    boy: '男性',
    girl: '女性',
    phone: '電話：',
    entryTime: 'エントリー時間',
    wechat: 'Wechat',
    qq: 'QQ',
    working: '現職',
    working1: '現職',
    working2: '辞職',
    yes: 'はい',
    no: 'いいえ',
    action: '操作',
    edit: '編集',
    edit_People: '編集スタッフ',
    Return_to_People_list: '人のリストに戻る',
    please_enter: '入力してください',
    please_enter_date: '日付を入力してください',
    save: '保存'
  },
  Maintain: {
    index: 'No.',
    DeviceName: 'マシン名',
    username: '所有者',
    startTime: '始動時間',
    endTime: '終了時間',
    remark: 'リマーク',
    action: '操作',
    edit: '編集',
    edit_Maintain: 'メンテナンス記録を編集する',
    Return_to_Maintain_list: '修理リストに戻る',
    save: '保存',
    please_enter: '入力してください',
    please_enter_date1: '注文の配信開始日',
    please_enter_date2: '注文の配信終了日'
  },
  Permission: {
    super_admin: 'スーパーシステム管理',
    system: 'システム設定',
    device: '設備設定',
    card: 'カード設定',
    people: '人員設定',
    product: '製品管理',
    order: '注文管理',
    production_plan: 'オーダー管理',
    monitor: 'モニタリング',
    report_export: '過去のレポート',
    R: '読む',
    W: '書く',
    RW: '読み書き'
  }
}, JP, jaE)

export default jaJP



// WEBPACK FOOTER //
// ./src/lang/ja-JP.js